export default function Counter() {
    $(document).on('click', '.counter__button', function () {
        var parent = $(this).closest('.counter');
        var input = $(this).siblings('.counter__input');
        var val = parseInt(input.val());
        var limit = parseInt(input.attr('maxlength'));
        var max = parent.data('max') || 999;

        if (input.is(':disabled')) return;

        if ($(this).hasClass('counter--plus')) {
            if (input.val() < max) {
                input.val((val += 1));
                input.trigger('change');
            }
        } else if ($(this).hasClass('counter--minus') && val > 1) {
            input.val((val -= 1));
            input.trigger('change');
        }

        parent.attr('data-value', val >= max ? 'max' : input.val());
    });

    $(document).on('focus', '.counter__input', function () {
        var parent = $(this).closest('.counter');
        var input = $(this).siblings('.counter__input');
        var val = parseInt(input.val());
        var max = parent.data('max') || 999;
        parent.attr('data-value', val >= max ? 'max' : input.val());
    });

    $(document).on('focusout', '.counter__input', function () {
        var input = $(this);
        var parent = $(this).closest('.counter');
        var value = input.val();
        var max = parent.data('max') || 999;

        if (input.is(':disabled')) return;

        if (
            $(this)
                .val()
                .replace(/[^0-9]/g, '').length == 0 ||
            $(this)
                .val()
                .replace(/[^0-9]/g, '') == 0
        ) {
            $(this).val('1');
        }
        if (value != input.val()) {
            input.trigger('change');
        }
        parent.attr('data-value', value >= max ? 'max' : input.val());
    });

    $(document).on('drop paste', '.counter__input', function (event) {
        event.preventDefault();
    });

    $(document).on('keydown', '.counter__input', function (event) {
        var input, parent, val, min, max, key;

        if (
            event.keyCode == 46 ||
            event.keyCode == 8 ||
            event.keyCode == 9 ||
            (event.keyCode == 65 && event.ctrlKey === true) ||
            (event.keyCode >= 35 && event.keyCode <= 39)
        ) {
            return;
        } else if (event.keyCode == 13 || event.keyCode == 27) {
            $(this).blur();
            return;
        } else {
            // If it's not a number stop the keypress
            if (
                event.shiftKey ||
                ((event.keyCode < 48 || event.keyCode > 57) &&
                    (event.keyCode < 96 || event.keyCode > 105))
            ) {
                event.preventDefault();
            } else {
                // input   = $(this)
                // parent  = input.closest('.counter');
                // val     = input.val();
                // min     = 1
                // max     = parent.data('max') || 999
                // key     = getNumKeyVal( event ).toString()
                // if( parseInt(val + key) > max) { input.val(max); return false }
            }
        }
    });

    $(document).on('keyup', '.counter__input', function (event) {
        var input = $(this);
        var parent = input.closest('.counter');
        if (!parent.attr('data-max')) return;
        var val = parseInt(input.val());
        var max = parent.data('max') || 999;
        parent.attr('data-value', val >= max ? 'max' : input.val());
        if (val == 0) {
            return input.val(1);
        }
        if (val > max) {
            return input.val(max);
        }
    });

    function getNumKeyVal(e) {
        // if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105)) {
        //     // 0-9 only
        // }
        var result = null;

        var KEYS = [
            [48, 96],
            [49, 97],
            [50, 98],
            [51, 99],
            [52, 100],
            [53, 101],
            [54, 102],
            [55, 103],
            [56, 104],
            [57, 105],
        ];

        $.each(KEYS, function (index, val) {
            for (var i = 0; i < val.length; i++) {
                if (val[i] == e.keyCode) {
                    return (result = index);
                }
            }
        });

        return result;
    }
}
